import { onMounted, createApp } from 'vue'
import { useStore } from 'vuex'
import Store from 'store'
import Mark from 'mark.js'
import DictionaryWord from '../DictionaryWord/DictionaryWord'

export default {
    name: 'Dictionary',
    components: { DictionaryWord },
    props: {
        wordObjects: {
            type: Array,
            required: true
        }
    },
    setup(props) {

        onMounted(() => {
            let words = []
            const options = {
                accuracy: {
                    value: 'exactly',
                    limiters: [',', '.', '?', '!', ';', ':']
                },
                exclude: ['a', 'h1', 'h2', 'h3', 'h4', 'h5'],
                separateWordSearch: false,
                element: 'span',
                className:
                    'kb-component--dictionary-word kb-dictionary-word__definition-set',
                each: (node) => {
                    
                    const currentWordObject = props.wordObjects.find(
                        (w) => {
                            if (w.word.toLowerCase() == node.innerText.toLowerCase() 
                                ||  w.word.toLowerCase() == node.innerHTML.toLowerCase()) {
                                return true
                            } 
                            return false
                        }
                    )   
                    if (currentWordObject) {
                        const wordData = {
                            id: currentWordObject.id,
                            word: node.innerHTML,
                            wordArticleUrl: currentWordObject.wordArticleUrl
                        }
                        node.setAttribute('data-word', JSON.stringify(wordData))
                        node.setAttribute(
                            'id',
                            'kb-component--dictionary-word__' +
                                Math.random().toString(16).slice(2)
                        )
                    }
                }
            }

            props.wordObjects.forEach((w) => words.push(w.word))


            document.querySelectorAll('.kb-rich-text').forEach((richText) => {
                const mark = new Mark(richText)
                mark.mark(words, options)
            })

            // Mount the DictionaryWord component to all the words contained in the dictionary
            const el = '.kb-component--dictionary-word'
            const DOMs = document.querySelectorAll(el)

            DOMs.forEach((DOM) => {
                if (
                    DOM &&
                    DOM.dataset.word &&
                    !DOM.hasAttribute('data-v-app')
                ) {
                    const wordObject = JSON.parse(DOM.dataset.word)
                    const component = createApp(DictionaryWord, {
                        domId: `#${DOM.id}`,
                        wordObject
                    }).use(Store)
                    component.mount(`#${DOM.id}`)
                }
            })
        })
    }
}
